import { render } from "./PolicyReports.vue?vue&type=template&id=4328b8c9"
import script from "./PolicyReports.vue?vue&type=script&lang=js"
export * from "./PolicyReports.vue?vue&type=script&lang=js"

import "./PolicyReports.vue?vue&type=style&index=0&id=4328b8c9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__